import { Theme, Components } from '@mui/material/styles';

export const CardOverrides: Components<Theme> = {
  MuiCard: {
    defaultProps: {},
    styleOverrides: {
      root: ({ theme }) => ({
        background: theme.palette.background.default,
        ...theme.applyStyles('dark', {
          background: theme.palette.background.paper,
        }),
      }),
    },
  },
  MuiCardContent: {
    defaultProps: {},
    styleOverrides: {
      root: ({ theme }) => ({
        padding: theme.spacing(3),
        background: theme.palette.background.default,
        ...theme.applyStyles('dark', {
          background: theme.palette.background.paper,
        }),
      }),
    },
  },
  MuiCardActions: {
    defaultProps: {},
    styleOverrides: {
      root: ({ theme }) => ({
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(3),
        paddingBottom: theme.spacing(2),
        paddingRight: theme.spacing(3),
      }),
    },
  },
};
